import ConvertManaModal from './ConvertManaModal.container'

export default ConvertManaModal
